<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-percent-table-4';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$gap: 4px;
$border: 2pt solid #c0bec7;
.task-percent-table-4 {
  --header-cell-height: 45px;
  --body-cell-height: 45px;
  thead {
    tr {
      th {
        padding: 0 $gap;
        & > div {
          color: #fff;
          border-left: $border;
          border-right: $border;
          &::after {
            @include _custom_table_bg;
            background: var(--theme-color-1);
          }
        }
      }
      &:first-child {
        th > div {
          border-top: $border;
        }
      }
    }
  }
  tbody {
    tr {
      td {
        padding: 0 $gap;
        & > div {
          border-left: $border;
          border-right: $border;
          background-color: var(--theme-color-1-10);
        }
      }

      &:last-child {
        td > div {
          border-bottom: $border;
        }
      }
    }
  }
}
</style>
